import { client } from "api";
import { Office } from "models/Office";

export type UpdateOfficeRequest = { id: number; name: string; orderReviewerId: string | null };

export type UpdateOfficeResponse = Office[];

export const updateOffice = ({ id, ...data }: UpdateOfficeRequest) =>
  client.put<UpdateOfficeResponse>(`/office/${id}`, data).then((res) => res.data);
